<template>
	<div class="_w-max">
		<div>
			<img style="width: 100%;" :src="agent_info.my_banner.url" />
		</div>
		<!-- 仓库地址 -->
		<warehouse-address></warehouse-address>
		<!-- 联系我们 -->
		<contact></contact>
	</div>
</template>

<script>
	import warehouseAddress from './components/warehouseAddress.vue';
	import contact from './components/contact.vue';
	import { bannerList } from '@/api/jiyun';
	export default {
		name: 'aboutUs',
		components: {
			warehouseAddress,
			contact
		},
		data() {
			return {
				metaInfo:{
					title: this.$t('page_title.about_us'),
				},
				agent_info: {},
			}
		},
		created(){
			this.bannerList();
		},
		metaInfo() {
			return {
				title: this.metaInfo.title
			}
		},
		methods: {
			bannerList(){
				let param = {
					domain_url: window.location.origin
				}
				bannerList(param).then((res)=>{
					this.agent_info = res.data;
				}).catch((err)=>{
					this.$Message.error(err.msg)
				})
			},
		}
	}
</script>

<style scoped>
	
</style>